import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ToastContainer } from 'react-toastify';
import React from "react";
export function Toastify() {
    return (_jsx(_Fragment, { children: _jsx(ToastContainer, { position: "top-right", autoClose: 8000, theme: "dark" }) }));
}
